import { mapParamsBySchema } from '../../util';
import { apiRequest } from '../../Services/Common/ApiRequest';
import Global from '../../Services/Common/Global';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../Hooks/apis/useQuriesSuccess';
import { M_EMT_BASIC_Schema } from './M_EMT_BASIC_Schema';

export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(M_EMT_BASIC_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['EmergencyTel', 'GetEmTelR1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.EmergencyTel.GetEmTelR1, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};
